<template>
  <div class="Label-staff">
    <div style="margin-bottom: 10px">
      <el-button type="primary" size="mini" @click="openLabel()">新建标签组</el-button>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table
          size="small"
          :data="tableData"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(100vh - 235px)"
          ref="cusChatTable"
          style="font-size: 13px"
          @row-dblclick="handleRowDBClick"
        >
          <!-- v-loading="loading"
          element-loading-text="拼命加载中" -->
          <el-table-column type="index" min-width="50"> </el-table-column>
          <el-table-column
            prop="groupName"
            label="标签组名称"
            min-width="120"
          ></el-table-column>
          <el-table-column prop="usageScenario" label="标签" min-width="200">
            <template slot-scope="scope">
              <div>
                <el-tag
                  style="margin: 5px 4px 0 0"
                  v-for="item in scope.row.hmcActivityTagList"
                  :key="item.tagId"
                  size="small"
                >
                  {{ item.tagName }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <el-button
                v-if="true"
                type="text"
                size="small"
                @click.native="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                v-if="true"
                type="text"
                size="small"
                @click.native="handleDel(scope.row)"
                >删除</el-button>
              <span v-if="!true" style="font-size: 12px">生成中</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <TagGroupCreateEdit
      :tagGroupDIaVisible="tagGroupDIaVisible"
      :diaTitle="this.diaTitle"
      :editData="this.editData"
      @cancelHandle="cancelHandle"
      @confirmHandle="confirmHandle"
    ></TagGroupCreateEdit>
  </div>
</template>
<script>
import { activityTagType, delTagGroup } from "@/api/activeCode/activeCode.js";
import TagGroupCreateEdit from "./tagsGroups/TagGroupDia";
import CusChatView from "../chat/components/CusChatView";
export default {
  name: "CusChatSupervise",
  components: {
    TagGroupCreateEdit,
    CusChatView,
  },
  data() {
    return {
      tableData: [], //标签组数据
      // loading: false,
      pageparm: {
        pageNum: 1,
        pageSize: 20,
        total: 20,
      },
      formInline: {
        pageNum: 1,
        pageSize: 20,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      tagGroupDIaVisible: false, //标签组弹窗
      diaTitle: "新建标签组",
      editData: null, //编辑的行数据
    };
  },
  created() {
    this.getTagsGroup();
  },
  methods: {
    //获取标签组
    getTagsGroup() {
      // this.loading = true;
      activityTagType(this.formInline, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            // this.loading = false;
            this.tableData = res.data.records;
            this.pageparm.total = res.data.total!=null?Number(res.data.total):0;
          }
        })
        .catch((err) => {});
    },
    //双击表格触发编辑
    handleRowDBClick(row){
      this.editData = row;
      this.diaTitle = "编辑标签组";
      this.tagGroupDIaVisible = true;
    },
    //分页回调
    callBack(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getTagsGroup();
    },
    // 打开新增弹窗
    openLabel() {
      this.editData = null;
      this.diaTitle = "新建标签组";
      this.tagGroupDIaVisible = true;
    },
    //取消新增回调
    cancelHandle() {
      this.tagGroupDIaVisible = false;
      this.getTagsGroup();
    },
    //确定新增回调
    confirmHandle() {
      this.tagGroupDIaVisible = false;
      if (this.editData == null) {
        this.$message.success("创建标签组成功");
      } else {
        this.$message.success("编辑标签组成功");
      }
      this.getTagsGroup()
    },
    // 删除标签组
    handleDel(row) {
      this.$confirm("","",{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          message:`<div style="font-size:15px;">确定删除该内容？</div><div style="font-size:12px;color:#999999">（删除后已添加至活码、客户信息中的标签将同步删除）</div>`,
          dangerouslyUseHTMLString:true,
          iconClass:"el-icon-warning",
          customClass:"delete-messege",
          center: true
        })
        .then(() => {
          delTagGroup(row.groupId, localStorage.getItem("Authorization")).then((res) => {
            if (res.error.code == 200) {
              this.getTagsGroup();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 编辑
    handleEdit(row) {
      this.editData = row;
      this.diaTitle = "编辑标签组";
      this.tagGroupDIaVisible = true;
    },
  },
};
</script>
<style lang="scss">
.Label-staff {
  .dialog-label {
    .el-dialog {
      max-height: 800px;
      overflow-y: scroll;
    }
    .el-dialog__body {
      padding-bottom: 10px;
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>
